import { render } from "./FullscreenButton.vue?vue&type=template&id=31cbeec4&scoped=true"
import script from "./FullscreenButton.vue?vue&type=script&lang=js"
export * from "./FullscreenButton.vue?vue&type=script&lang=js"

import "./FullscreenButton.vue?vue&type=style&index=0&id=31cbeec4&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31cbeec4"]])

export default __exports__